import { render, staticRenderFns } from "./topicsItem.vue?vue&type=template&id=2c54e691&"
import script from "./topicsItem.vue?vue&type=script&lang=js&"
export * from "./topicsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports